// Query configuration constants
export const QUERY_CONFIG = {
    STALE_TIME: 5 * 60 * 1000, // 5 minutes
    REFETCH_ON_WINDOW_FOCUS: false,
    TIMEOUT: 120000, // 120 seconds
};

// Pagination constants
export const PAGINATION = {
    ITEMS_PER_PAGE: 10,
    DEFAULT_LIMIT: 10,
    DEFAULT_PAGE: 1,
    MAX_COUNT: 100, // Fallback for pagination
    TOTAL_PAGES: 100,
};

// Loading timeouts
export const TRANSITIONS = {
    FADE_TIMEOUT: 300,
    OPACITY_TRANSITION: '0.2s ease-in-out',
};

// Table pagination constants
export const TABLE_PAGINATION = {
    DEFAULT_ROWS_PER_PAGE: 25,
    ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
};

export const DRAWER_WIDTH = 450;

/**
 * Quality score level types and thresholds for call filtering and display.
 * These levels determine the color coding of quality scores in the UI.
 *
 * NOTE: These values must match the server-side constants in server/src/utils/constants.ts
 */
export const QUALITY_SCORE_LEVELS = {
    GOOD: 'good',
    NEUTRAL: 'neutral',
    NEEDS_ATTENTION: 'needs_attention',
} as const;

export type QualityScoreLevel = (typeof QUALITY_SCORE_LEVELS)[keyof typeof QUALITY_SCORE_LEVELS];

export const QUALITY_SCORE_THRESHOLDS = {
    GOOD_MIN: 60, // 60-100% = Green (success)
    NEUTRAL_MIN: 50, // 50-60% = Yellow (warning)
    // Below 50% = Red (error/needs attention)
} as const;

export const QUALITY_SCORE_LABELS = {
    [QUALITY_SCORE_LEVELS.GOOD]: 'Good',
    [QUALITY_SCORE_LEVELS.NEUTRAL]: 'Neutral',
    [QUALITY_SCORE_LEVELS.NEEDS_ATTENTION]: 'Needs attention',
} as const;

export type QualityScoreColorShade = 'light' | 'dark';

export interface QualityScoreColors {
    [QUALITY_SCORE_LEVELS.GOOD]: { light: string; dark: string };
    [QUALITY_SCORE_LEVELS.NEUTRAL]: { light: string; dark: string };
    [QUALITY_SCORE_LEVELS.NEEDS_ATTENTION]: { light: string; dark: string };
}

/** Custom colors per quality level (light and dark). Override this object to change app-wide quality score colors. */
export const QUALITY_SCORE_COLORS: QualityScoreColors = {
    [QUALITY_SCORE_LEVELS.GOOD]: { light: '#DFF2E7', dark: 'green.60' },
    [QUALITY_SCORE_LEVELS.NEUTRAL]: { light: 'yellow.10', dark: 'yellow.60' },
    [QUALITY_SCORE_LEVELS.NEEDS_ATTENTION]: { light: '#F5DDDF', dark: 'red.60' },
};

export { API_ENDPOINTS, API_CONFIG, buildApiUrl, buildQueryParams } from './api';
